/**
 * @generated SignedSource<<c54ddbc87bf4a1b828ac949af08cfc71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillAncestriesFilterInput = {
  ancestorSkillIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  onlyGreaterThanZeroWeight?: boolean | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  skillRelevanceIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardSkillAncestriesQuery$variables = {
  filter?: SkillAncestriesFilterInput | null | undefined;
  skip: boolean;
};
export type DashboardSkillAncestriesQuery$data = {
  readonly skillAncestries?: ReadonlyArray<{
    readonly ancestorSkillId: number;
    readonly baseSkillId: number;
    readonly id: string;
    readonly isActive: boolean;
    readonly skillRelevance: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly weight: number;
  }>;
};
export type DashboardSkillAncestriesQuery = {
  response: DashboardSkillAncestriesQuery$data;
  variables: DashboardSkillAncestriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "SkillAncestryNode",
        "kind": "LinkedField",
        "name": "skillAncestries",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baseSkillId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ancestorSkillId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillRelevanceNode",
            "kind": "LinkedField",
            "name": "skillRelevance",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSkillAncestriesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardSkillAncestriesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f4409feab08c56e119c3b2cf549586a3",
    "id": null,
    "metadata": {},
    "name": "DashboardSkillAncestriesQuery",
    "operationKind": "query",
    "text": "query DashboardSkillAncestriesQuery(\n  $filter: SkillAncestriesFilterInput\n  $skip: Boolean!\n) {\n  skillAncestries(filter: $filter) @skip(if: $skip) {\n    id\n    weight\n    isActive\n    baseSkillId\n    ancestorSkillId\n    skillRelevance {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b19e04650f94e65ae391a5dee4228038";

export default node;
